import classNames from "classnames";
import { HTMLProps, ReactNode, useMemo } from "react";
import useRefSizeObserver from "../hooks/useRefSizeObserver";
import DEVICE_SIZES from "../helpers/constants/device-sizes";

export type FullScreenContainerInputProps = {
  children: ReactNode;
  centerContent?: boolean;
  hasNav?: boolean;
} & HTMLProps<HTMLDivElement>;

function FullScreenContainer({
  className,
  centerContent,
  hasNav = true,
  ...props
}: FullScreenContainerInputProps) {
  const width = useRefSizeObserver();
  const isMaxWidth = useMemo(() => width > DEVICE_SIZES.full, [width]);

  return (
    <div
      {...props}
      className={classNames(
        !isMaxWidth && "relative left-1/2 right-1/2 -mx-[var(--viewportWidth50)] w-[var(--viewportWidth)]",
        isMaxWidth && `mx-auto max-w-screen`,
        className,
        hasNav ? "min-h-[var(--viewportHeight)]" : "min-h-[100vh]",
        centerContent && "flex items-center justify-center text-center",
      )}
    >
      {props.children}
    </div>
  );
}

export default FullScreenContainer;
